import { Select, Spin, SelectProps } from 'antd';
import { isArray, debounce } from 'lodash';
import React, { FC, useState } from 'react';
import { PropsWithStyle } from './types';

export interface RemoteSelectorProps<T = any> extends SelectProps<T> {
  wait?: number;
  fetcher?: (search: string) => Promise<{ label: string, value: string }[]>;
}

export const RemoteUserSelector: FC<PropsWithStyle<RemoteSelectorProps>> = (props) => {
  const { wait = 500, fetcher, ...resetProps } = props;
  const [options, setOptions] = useState<any>([]);
  const [fetching, setFetching] = React.useState(false);
  const fetchRef = React.useRef(0);

  const debounceFetcher = React.useMemo(() => {
    const loadOptions = (value: string) => {
      if (!value.trim()) {
        setOptions([]);
        setFetching(false);
        return;
      }
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setFetching(true);
      setOptions([]);
      fetcher?.(value).then((userList) => {
        const formatUserList = !isArray(userList) ? [] : userList;
        if (fetchId !== fetchRef.current) {
          return;
        }

        setOptions(formatUserList);
        setFetching(false);
      });
    };

    return debounce(loadOptions, wait);
  }, []);

  return (
    <Select
      filterOption={false}
      onSearch={debounceFetcher}
      onChange={props.onChange}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      options={options}
      {...resetProps}
    />
  );
};
